var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "8a6a12cc968769f5ef31b3bcc3cd38d8c8563abd"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["www-ligonier-org@ligonier"] = {
  id: "8a6a12cc968769f5ef31b3bcc3cd38d8c8563abd"
};